"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMarketGroupsByEventV3 = exports.selectVirtualCategoriesInfos = exports.selectVirtualCategoriesInfosByEvent = exports.selectVirtualCategoriesInfosByEventEntries = exports.selectMarketGroupsByEvent = exports.selectMarketCategoriesInfosByEventFiltered = exports.selectGroupCategoriesMapFilterForMarketCategoriesInfosByEvent = exports.selectMarketGroupForGroupCategoriesMapFilter = exports.selectMarketCategoriesInfosByEventExists = exports.selectMarketCategoriesInfosByEvent = exports.selectmarketCategoriesInfosByEvent = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const slices_1 = require("../../../utils/@reduxjs/slices");
const selectors_1 = require("../../CommonDataProvider/selectors");
const utils_1 = require("../utils");
const regExp_1 = require("../../../utils/regExp");
const array_1 = require("../../../utils/array");
const selectmarketCategoriesInfosByEvent = (state) => {
    return state.eventsProvider.marketCategoriesInfosByEvent.entries;
};
exports.selectmarketCategoriesInfosByEvent = selectmarketCategoriesInfosByEvent;
const selectMarketCategoriesInfosByEvent = (state, eventId) => {
    return (state.eventsProvider.marketCategoriesInfosByEvent.entries[eventId] ||
        array_1.EMPTY_ARRAY);
};
exports.selectMarketCategoriesInfosByEvent = selectMarketCategoriesInfosByEvent;
const selectMarketCategoriesInfosByEventExists = (state, eventId) => state.eventsProvider.marketCategoriesInfosByEvent.entries[eventId];
exports.selectMarketCategoriesInfosByEventExists = selectMarketCategoriesInfosByEventExists;
const selectMarketGroupForGroupCategoriesMapFilter = (state, _, marketGroupId) => (marketGroupId ? (0, selectors_1.selectMarketGroupById)(state, marketGroupId) : null);
exports.selectMarketGroupForGroupCategoriesMapFilter = selectMarketGroupForGroupCategoriesMapFilter;
exports.selectGroupCategoriesMapFilterForMarketCategoriesInfosByEvent = (0, toolkit_1.createSelector)([exports.selectMarketGroupForGroupCategoriesMapFilter], (marketGroup) => {
    if (marketGroup) {
        // Extract category market IDs from the selected market group, if specified
        const result = (0, mapValues_1.default)((0, slices_1.toIdsMap)(marketGroup.categories, 'marketCategoryId'), (groupCategory) => new Set(groupCategory.categoryMarketIds) // For fast lookup
        );
        return result;
    }
    else {
        return null;
    }
});
const selectSearchFilterForMarketCategoriesInfosByEvent = (_, __, ___, search) => search;
const selectStatusFilterForMarketCategoriesInfosByEvent = (_, __, ___, search, tradingStatus) => tradingStatus;
exports.selectMarketCategoriesInfosByEventFiltered = (0, toolkit_1.createSelector)([
    exports.selectMarketCategoriesInfosByEvent,
    exports.selectGroupCategoriesMapFilterForMarketCategoriesInfosByEvent,
    selectSearchFilterForMarketCategoriesInfosByEvent,
    selectStatusFilterForMarketCategoriesInfosByEvent,
], (marketCategoriesInfos, groupCategoriesMapFilter, searchFilter, tradingStatusFilter) => {
    const searchRegExp = searchFilter ? (0, regExp_1.regExpSearchString)(searchFilter) : null;
    const searchRegExpReplace = (0, utils_1.searchRegExpReplaceFunc)(searchRegExp);
    return marketCategoriesInfos.reduce((filteredMarketCategoriesInfosAcc, { marketCategoryId, marketCategoryName, categoryMarketInfos }) => {
        let updatedMarketCategoryName = '';
        // Check against groupCategoriesMapFilter if it exists
        const marketGroupCategoriesMapFilter = groupCategoriesMapFilter
            ? groupCategoriesMapFilter[marketCategoryId]
            : null;
        // Apply groupCategoriesMapFilter if applicable
        let filteredCategoryMarketInfos = groupCategoriesMapFilter
            ? marketGroupCategoriesMapFilter
                ? categoryMarketInfos.filter(({ id }) => marketGroupCategoriesMapFilter.has(id))
                : []
            : categoryMarketInfos;
        // Apply tradingStatusFilter if applicable
        if (tradingStatusFilter) {
            filteredCategoryMarketInfos = filteredCategoryMarketInfos.filter((categoryMarketInfo) => categoryMarketInfo.tradingStatus === tradingStatusFilter);
        }
        // Apply searchFilter if applicable
        if (searchRegExp) {
            // If marketCategoryName matches the search, keep all categoryMarketInfos as they are.
            // Otherwise, filter categoryMarketInfos based on the searchRegExp match against their title.
            if (!(0, utils_1.doesStringMatchSearchRegExp)(marketCategoryName, searchRegExp)) {
                filteredCategoryMarketInfos = filteredCategoryMarketInfos
                    .filter(({ title }) => (0, utils_1.doesStringMatchSearchRegExp)(title, searchRegExp))
                    .map(({ title, ...rest }) => ({
                    ...rest,
                    title: searchRegExpReplace(title),
                }));
            }
            else {
                updatedMarketCategoryName = searchRegExpReplace(marketCategoryName);
            }
        }
        // Only include categories that have at least one matching market info after filtering
        if (filteredCategoryMarketInfos.length > 0) {
            filteredMarketCategoriesInfosAcc.push({
                marketCategoryId,
                marketCategoryName: updatedMarketCategoryName || marketCategoryName,
                categoryMarketInfos: filteredCategoryMarketInfos,
            });
        }
        return filteredMarketCategoriesInfosAcc;
    }, []);
});
exports.selectMarketGroupsByEvent = (0, toolkit_1.createSelector)([exports.selectMarketCategoriesInfosByEvent, selectors_1.selectMarketGroups], (marketCategoriesInfos, marketGroups) => {
    // For fast lookup
    const marketCategoriesInfosMap = (0, mapValues_1.default)((0, slices_1.toIdsMap)(marketCategoriesInfos, 'marketCategoryId'), (marketCategoryInfo) => new Set(marketCategoryInfo.categoryMarketInfos.map((categoryMarketInfo) => categoryMarketInfo.id)));
    // Filter the marketGroups according to event's marketCategoriesInfos
    return marketGroups.filter((marketGroup) => marketGroup.categories.some((category) => category.categoryMarketIds.some((categoryMarketId) => {
        var _a;
        return (_a = marketCategoriesInfosMap[category.marketCategoryId]) === null || _a === void 0 ? void 0 : _a.has(categoryMarketId);
    })));
});
const selectVirtualCategoriesInfosByEventEntries = (state) => {
    return state.eventsProvider.virtualCategoriesInfosByEvent.entries;
};
exports.selectVirtualCategoriesInfosByEventEntries = selectVirtualCategoriesInfosByEventEntries;
const selectVirtualCategoriesInfosByEvent = (state, eventId) => {
    return ((0, exports.selectVirtualCategoriesInfosByEventEntries)(state)[eventId] || array_1.EMPTY_ARRAY);
};
exports.selectVirtualCategoriesInfosByEvent = selectVirtualCategoriesInfosByEvent;
exports.selectVirtualCategoriesInfos = (0, toolkit_1.createSelector)([
    exports.selectVirtualCategoriesInfosByEvent,
    exports.selectGroupCategoriesMapFilterForMarketCategoriesInfosByEvent,
    selectSearchFilterForMarketCategoriesInfosByEvent,
    selectStatusFilterForMarketCategoriesInfosByEvent,
], (marketCategoriesInfos, groupCategoriesMapFilter, searchFilter, tradingStatusFilter) => {
    const searchRegExp = searchFilter ? (0, regExp_1.regExpSearchString)(searchFilter) : null;
    const searchRegExpReplace = (0, utils_1.searchRegExpReplaceFunc)(searchRegExp);
    return marketCategoriesInfos.reduce((filteredMarketCategoriesInfosAcc, { categoryId, categoryName, virtualMarkets }) => {
        let updatedMarketCategoryName = '';
        // Check against groupCategoriesMapFilter if it exists
        const marketGroupCategoriesMapFilter = groupCategoriesMapFilter
            ? groupCategoriesMapFilter[categoryId]
            : null;
        // Apply groupCategoriesMapFilter if applicable
        let filteredCategoryMarketInfos = groupCategoriesMapFilter
            ? marketGroupCategoriesMapFilter
                ? virtualMarkets.filter(({ id }) => marketGroupCategoriesMapFilter.has(id))
                : []
            : virtualMarkets;
        // Apply tradingStatusFilter if applicable
        if (tradingStatusFilter) {
            filteredCategoryMarketInfos = filteredCategoryMarketInfos.filter((categoryMarketInfo) => categoryMarketInfo.tradingStatus === tradingStatusFilter);
        }
        // Apply searchFilter if applicable
        if (searchRegExp) {
            // If marketCategoryName matches the search, keep all categoryMarketInfos as they are.
            // Otherwise, filter categoryMarketInfos based on the searchRegExp match against their title.
            if (!(0, utils_1.doesStringMatchSearchRegExp)(categoryName, searchRegExp)) {
                filteredCategoryMarketInfos = filteredCategoryMarketInfos
                    .filter(({ outcomesGroup }) => (0, utils_1.doesStringMatchSearchRegExp)(outcomesGroup.name || '', searchRegExp))
                    .map(({ outcomesGroup, ...rest }) => ({
                    ...rest,
                    outcomesGroup: {
                        ...outcomesGroup,
                        name: searchRegExpReplace(outcomesGroup.name || ''),
                    },
                }));
            }
            else {
                updatedMarketCategoryName = searchRegExpReplace(categoryName);
            }
        }
        // Only include categories that have at least one matching market info after filtering
        if (filteredCategoryMarketInfos.length > 0) {
            filteredMarketCategoriesInfosAcc.push({
                categoryId,
                categoryName: updatedMarketCategoryName || categoryName,
                virtualMarkets: filteredCategoryMarketInfos,
            });
        }
        return filteredMarketCategoriesInfosAcc;
    }, []);
});
exports.selectMarketGroupsByEventV3 = (0, toolkit_1.createSelector)([exports.selectVirtualCategoriesInfosByEvent, selectors_1.selectMarketGroups], (marketCategoriesInfos, marketGroups) => {
    // For fast lookup
    const marketCategoriesInfosMap = (0, mapValues_1.default)((0, slices_1.toIdsMap)(marketCategoriesInfos, 'categoryId'), (marketCategoryInfo) => new Set(marketCategoryInfo.virtualMarkets.map((categoryMarketInfo) => categoryMarketInfo.id)));
    // Filter the marketGroups according to event's marketCategoriesInfos
    return marketGroups.filter((marketGroup) => marketGroup.categories.some((category) => category.categoryMarketIds.some((categoryMarketId) => {
        var _a;
        return (_a = marketCategoriesInfosMap[category.marketCategoryId]) === null || _a === void 0 ? void 0 : _a.has(categoryMarketId);
    })));
});
//# sourceMappingURL=marketSelectors.js.map